import { render } from "./HomePageDonutItem.vue?vue&type=template&id=d9021568&scoped=true"
import script from "./HomePageDonutItem.vue?vue&type=script&lang=js"
export * from "./HomePageDonutItem.vue?vue&type=script&lang=js"

import "./HomePageDonutItem.vue?vue&type=style&index=0&id=d9021568&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9021568"]])

export default __exports__